import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function PanelVisitas(props) {
    return (
        <Fragment><br/>
            <div className='container'>
            <h1>Panel Visitas</h1>
            </div>
        </Fragment>
    );
};


export default withRouter(PanelVisitas)
